export default __webpack_public_path__ + "static/media/企画旅行の催行について.fe04998a.pdf";